export default __webpack_public_path__ + "static/media/More.aed86057.svg";